import { Controller } from "@hotwired/stimulus";

/**
 * 法人代表者の情報を担当者フィールドにコピーするコントローラー
 *
 * プロフィール編集画面で「担当者を代表者と同じにする」ボタンを押下時に
 * 代表者の姓名・かな情報を担当者フィールドに自動入力する
 */
export default class extends Controller {
  static targets = [
    "fromFamilyName",
    "fromGivenName",
    "fromFamilyNameKana",
    "fromGivenNameKana",
    "toFamilyName",
    "toGivenName",
    "toFamilyNameKana",
    "toGivenNameKana",
  ];

  /**
   * 代表者情報を担当者フィールドにコピーする
   *
   * ボタン押下時に呼び出され、代表者の姓名・かな情報を
   * 対応する担当者フィールドにコピーする
   */
  copy() {
    // 代表者の姓を担当者の姓にコピー
    if (this.hasFromFamilyNameTarget && this.hasToFamilyNameTarget) {
      this.#copyField(this.fromFamilyNameTarget, this.toFamilyNameTarget);
    }

    // 代表者の名を担当者の名にコピー
    if (this.hasFromGivenNameTarget && this.hasToGivenNameTarget) {
      this.#copyField(this.fromGivenNameTarget, this.toGivenNameTarget);
    }

    // 代表者の姓（かな）を担当者の姓（かな）にコピー
    if (this.hasFromFamilyNameKanaTarget && this.hasToFamilyNameKanaTarget) {
      this.#copyField(
        this.fromFamilyNameKanaTarget,
        this.toFamilyNameKanaTarget,
      );
    }

    // 代表者の名（かな）を担当者の名（かな）にコピー
    if (this.hasFromGivenNameKanaTarget && this.hasToGivenNameKanaTarget) {
      this.#copyField(this.fromGivenNameKanaTarget, this.toGivenNameKanaTarget);
    }
  }

  /**
   * フィールドの値をコピーしてinputイベントを発火する
   *
   * @private
   * @param {HTMLInputElement} fromTarget - コピー元のinput要素
   * @param {HTMLInputElement} toTarget - コピー先のinput要素
   */
  #copyField(fromTarget, toTarget) {
    toTarget.value = fromTarget.value;
    toTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
